export enum UmpirePageComponentSize {
  DEFAULT = 'default',
}
